import React, { useRef, useEffect, useState } from 'react';
import { useWindowSize } from './utils';

export interface TableProps extends React.HTMLAttributes<HTMLTableElement> {}

export const Table = (props: TableProps) => {
  const [scrollable, setScrollable] = useState(false);
  const tableRef = useRef<HTMLTableElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const { width } = useWindowSize();

  useEffect(() => {
    if (!tableRef.current || !containerRef.current) return;
    const show =
      tableRef.current.clientWidth > containerRef.current.clientWidth;
    setScrollable(show);
  }, [width]);

  return (
    <div ref={containerRef} className="table-wrapper">
      {scrollable && (
        <div className="scroll-notice">
          &#8672; <span>Scrollable</span> &#8674;
        </div>
      )}
      <table ref={tableRef} {...props} />
    </div>
  );
};
